import { useEffect, useRef } from 'react';

const useContentElement = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    ref.current = document.getElementById('content') as HTMLDivElement;
  }, []);

  return ref;
};

export default useContentElement;
